import type { DraftInput } from '../../../../shared/drafts';

function createQuestion(level: number): DraftInput['questions'][number] {
  return {
    prompt: `${level}. soru`,
    wagonStyle: 'wide',
    levels: [level],
    choices: [
      { text: 'Doğru cevap', isCorrect: true },
      { text: 'Yanlış cevap 1', isCorrect: false },
      { text: 'Yanlış cevap 2', isCorrect: false },
    ],
  };
}

export function createFieryRouteDraft(): DraftInput {
  return {
    title: 'Yeni Alevli Rota',
    templateKey: 'fiery-route',
    levelMode: 'manual',
    maxLevels: 1,
    trackTime: true,
    // Yeni oyunlar Normal modla açılır: öğrenci bütün soruları görür (2026-09-27 kullanıcı kararı).
    bridgeMode: 'guided',
    questions: [createQuestion(1)],
  };
}

export function resizeFieryRouteDraft(draft: DraftInput, maxLevels: number): DraftInput {
  const safeLevels = Math.max(1, Math.min(10, Math.trunc(maxLevels)));
  const questions = Array.from({ length: safeLevels }, (_, index) => {
    const level = index + 1;
    const existing = draft.questions.find((question) => question.levels[0] === level);
    return { ...(existing ?? createQuestion(level)), levels: [level] };
  });
  return { ...draft, templateKey: 'fiery-route', levelMode: 'manual', maxLevels: safeLevels, trackTime: true, questions };
}
